export const DEBT_UNSOLVED_STAGE = "unsolved"
export const DEBT_DRAFT_PAYMENT_SCHEDULE_STAGE = "draft_payment_schedule"
export const DEBT_DRAFT_SENT_TO_SELF_SERVICE = "draft_sent_to_self_service"
export const DEBT_PAYMENT_SCHEDULE_STAGE = "payment_schedule"
export const DEBT_OVERDUE_STAGE = "overdue"
export const DEBT_COURT_PREPARING_STAGE = "court_preparing"
export const DEBT_COURT_STAGE = "court"
export const DEBT_BAILIFF_STAGE = "bailiff"
export const DEBT_PAID_STAGE = "paid"
export const DEBT_ENDED_STAGE = "ended"

export const DEBT_NON_PAYABLE_BALANCE = 10000
